import { createFileRoute, redirect } from '@tanstack/react-router';
import { SubscriptionsPage } from '../components/profile/settings/SubscriptionsPage';

export const Route = createFileRoute('/profile/settings/subscriptions')({
  beforeLoad: ({ location }) => {
    if (!localStorage.getItem('access_token')) {
      throw redirect({ to: '/sign-in', search: { redirect: location.pathname } });
    }
  },
  component: SubscriptionsPage,
});
